"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APQRCode = _interopRequireDefault(require("../../common/APQRCode/APQRCode"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _clipboardHelper = _interopRequireDefault(require("../../../helpers/clipboardHelper"));
var _destinationTagHelper2 = _interopRequireDefault(require("../../../helpers/destinationTagHelper"));
var _APSelect = require("../../common/APSelect");
require("./ReceiveAddress.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('receive-address');
var ReceiveAddressComponent = /*#__PURE__*/function (_React$Component) {
  function ReceiveAddressComponent() {
    var _this;
    _classCallCheck(this, ReceiveAddressComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReceiveAddressComponent, [].concat(args));
    _defineProperty(_this, "state", {
      selectedAccountProviderId: null
    });
    _defineProperty(_this, "handleSelectAccountProvider", function (accountProviderId) {
      var _this$props = _this.props,
        fetchAccountProviderDepositInfo = _this$props.fetchAccountProviderDepositInfo,
        product = _this$props.product;
      if (!accountProviderId) {
        return _this.setState({
          selectedAccountProviderId: accountProviderId
        });
      }
      fetchAccountProviderDepositInfo(product.ProductId, accountProviderId);
      _this.setState({
        selectedAccountProviderId: accountProviderId
      });
    });
    return _this;
  }
  _inherits(ReceiveAddressComponent, _React$Component);
  return _createClass(ReceiveAddressComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        selectDepositProduct = _this$props2.selectDepositProduct,
        product = _this$props2.product;
      selectDepositProduct(product.ProductId);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props3 = this.props,
        addressList = _this$props3.deposit.depositInfo,
        _this$props3$deposit = _this$props3.deposit,
        isLoading = _this$props3$deposit.isLoading,
        error = _this$props3$deposit.error,
        templateTypes = _this$props3$deposit.templateTypes,
        product = _this$props3.product,
        showSnack = _this$props3.showSnack,
        WalletsDisabledMessage = _this$props3.WalletsDisabledMessage;
      var selectedAccountProviderId = this.state.selectedAccountProviderId;

      // Protocol prefix for the QR Code, lowercase name with no spaces.
      var depositType = product.ProductFullName.toLowerCase().replace(/\W/g, '');
      var templateTypeOptions = [{
        value: '',
        label: 'Select an option',
        disabled: true,
        selected: true
      }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template.AccountProviderName
        };
      })));
      var selectedAddress;
      if (!isLoading && addressList.length) {
        selectedAddress = addressList[addressList.length - 1];
      }
      var _destinationTagHelper = (0, _destinationTagHelper2["default"])(selectedAddress),
        address = _destinationTagHelper.address,
        dt = _destinationTagHelper.dt,
        memo = _destinationTagHelper.memo;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses()
      }, templateTypes.length ? /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
        name: "AccountProvider",
        customClass: bemClasses('account-provider-select'),
        label: t('Select an option to continue the deposit process'),
        onSelect: this.handleSelectAccountProvider,
        options: templateTypeOptions
      }) : /*#__PURE__*/_react["default"].createElement("div", null, t('No account providers are configured')), selectedAddress && selectedAccountProviderId && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('description')
      }, t('Scan this QR code to receive funds:')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('qr-code')
      }, /*#__PURE__*/_react["default"].createElement(_APQRCode["default"], {
        value: "".concat(depositType, ":").concat(selectedAddress)
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('copy-address-text')
      }, t('Or copy this address:')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('copy-address-payload'),
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(address);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The address has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, address), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), dt && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(dt);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The destination tag has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('destination-tag-text')
      }, t('Be sure to include this destination tag:')), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, dt), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), memo && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(memo);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The memo tag has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('memo-tag-text')
      }, t('Be sure to include this memo tag:')), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, memo), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      }))), isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        text: t('Loading url...'),
        customClass: bemClasses
      }), WalletsDisabledMessage ? /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('error')
      }, t(WalletsDisabledMessage)) : error && /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('error')
      }, t(error)));
    }
  }]);
}(_react["default"].Component);
ReceiveAddressComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    templateTypes: [],
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  },
  product: {}
};
ReceiveAddressComponent.propTypes = {
  product: _propTypes["default"].object,
  deposit: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object.isRequired,
    templateTypes: _propTypes["default"].object.isRequired,
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string.isRequired,
    product: _propTypes["default"].number,
    depositInfo: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,
    depositStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('send')(ReceiveAddressComponent);